module.exports = __webpack_public_path__ + "img/samira-daniel-1712041L.f67906b8.jpg";